/* eslint-disable */
<template lang="pug">
.detalhe-processo
  el-row(v-if="!isCadastroPendente")
    cabecalho-processo
  el-row(v-if="!isCadastroPendente")
    app-download-titulo
  el-row
    router-view(:isCadastroPendente="isCadastroPendente")
  app-cabecalho.marginLeft(v-if="verificaBotaoAtivo()", titulo="Voltar", route="central/processos")

</template>

<script>
import AppCabecalho from '../../../components/AppCabecalho'
import CabecalhoProcesso from './CabecalhoProcesso'
import AppDownloadTitulo from './AppDownloadTitulo'

export default {
  components: {
    AppCabecalho,
    CabecalhoProcesso,
    AppDownloadTitulo
  },

  props: {
    isCadastroPendente: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    verificaBotaoAtivo () {
      return !(this.$route.name !== 'calculo-pagamento' || this.$route.name !== 'vtn/escolher-forma-pagamento')
    }
  }
}
</script>
<style lang="scss" scoped>
.detalhe-processo {
  padding: 20px;
}

.marginLeft {
  margin-left: 37px;
}

.component {
  z-index: 2;
  .center {
    display: flex;
    align-items: center;
  }

  .text {
    color: #575757;
    padding: 0;
  }
}

@media (max-width: 780px) {
  .detalhe-processo {
    padding: 0;
    position: relative;
    top: 75px;
    right: 50%;
    width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/processos/DetalhesProcesso.vue